---
de:
  notifications:
    admin:
      channels:
        email: E-Mail
        portal_toast: Portal-Toast
      composer:
        fields:
          all_users: Alle Benutzer
          body: Nachrichtentext
          channels: Kanäle
          community_post: Community-Beitrag verlinken
          context_url: Kontext-URL (optional)
          direct_users: Direkte Empfänger
          features: Feature-Flags
          portfolios: Portfolios
          scope: Umfang
          send: Benachrichtigung senden
          severity: Schweregrad
          title: Titel
        hints:
          all_users_caption: Mit Vorsicht für breit gestreute Mitteilungen verwenden.
          all_users_tooltip: Sendet an alle aktiven Portalbenutzer innerhalb Ihres aktuellen Geltungsbereichs.
          channels: Wählen Sie vor dem Versand Zustellkanäle und Zielsegmente aus.
          context: Fügen Sie optional einen Link hinzu, der den Zweck der Benachrichtigung erklärt.
          layout_intro: Erstellen Sie zuerst die Nachricht und prüfen Sie dann Empfänger und Kanäle vor dem Versand.
          targeting: Kombinieren Sie direkte Nutzer, Portfolios und Feature-Flags, um den Empfängerkreis zu steuern.
        preview:
          direct_users: Direkte Benutzer
          features: Feature-Flags
          portfolios: Portfolios
        preview_headers:
          email: E-Mail
          recipient: Empfänger
        recipient_notice:
          all_users: Versand an alle Portalbenutzer.
          direct_summary: "{count} direkt"
          feature_summary: "{count} über {feature}"
          loading: Empfängeranzahl wird berechnet...
          portfolio_summary: "{count} aus {name}"
          select: Bitte wählen Sie mindestens einen Empfänger über direkte Nutzer, Portfolios oder Feature-Flags aus.
          separator: " • "
          summary: Es werden {count} Empfänger benachrichtigt{details}
        sections:
          audience: Empfängerkreis
          channels: Kanäle & Segmente
          context: Nachrichtenkontext
          delivery: Zustellung
          message: Nachrichteninhalt
          preview: Empfängervorschau
          review: Prüfen & Senden
          settings: Benachrichtigungseinstellungen
          targeting: Direkte Zielgruppen
        send_summary:
          channels: 'Kanäle: {value}'
          no_channels: Keine Kanäle ausgewählt
          recipients: 'Empfänger: {count}'
          scope: 'Umfang: {value}'
          scope_all_users: Alle Benutzer
          scope_selected: Ausgewählte Empfänger
          severity: 'Schweregrad: {value}'
          title: Sendeübersicht
        severities:
          error: Fehler
          info: Info
          success: Erfolg
          warning: Warnung
        title: Benachrichtigung erstellen
      delivery_status_reasons:
        email_channel_disabled: E-Mail-Kanal deaktiviert
        invalid_email: Ungültiges E-Mail-Format
        missing_recipient_email: Empfängeradresse fehlt
        missing_user_mapping: Fehlende Benutzerzuordnung
        portal_toast_channel_disabled: Portal-Toast deaktiviert
        portal_toast_opted_out: Nutzer hat In-App-Popups deaktiviert
        whitelist_block: Durch Allowlist blockiert
      delivery_statuses:
        blocked_by_kill_switch: Durch Not-Aus blockiert
        dropped_by_whitelist: Durch Allowlist verworfen
        sent: Gesendet
        skipped_invalid_recipient: Übersprungen (ungültiger Empfänger)
        suppressed_by_user_preference: Durch Nutzerpräferenz unterdrückt
      health:
        alert: Hohe Aktivität erkannt. Prüfen Sie die letzten Zustellungen und pausieren Sie bei Bedarf einen Kanal.
        no_activity: Keine aktuelle Aktivität
        per_channel_title: Zustellungen in den letzten {minutes} Minuten
        range_15m: Letzte 15 Minuten
        range_1h: Letzte Stunde
        range_24h: Letzte 24 Stunden
        range_7d: Letzte 7 Tage
        range_label: Aktivitätsfenster
        top_recipients_title: Top-Empfänger ({minutes} Minuten)
      reports:
        channel_breakdown_title: Kanalaufteilung
        channel_series_label: Zustellungen
        delivery_reason_empty: Keine Fehlerursachen bei der Zustellung
        delivery_reason_title: Ursachen für fehlgeschlagene Zustellung
        delivery_status_all: Alle Status
        delivery_status_empty: Keine Zustellstatusdaten
        delivery_status_label: Zustellstatus
        delivery_status_title: Zustellstatus
        errors:
          preview: Empfängervorschau fehlgeschlagen
          refresh: Aktualisieren des Berichts fehlgeschlagen
          trigger: Auslösen der Benachrichtigung fehlgeschlagen
        failed_job_alerts_channel: 'E-Mail-Kanal: {enabled}'
        failed_job_alerts_email_disabled: E-Mail-Kanal ist für diesen Benutzer deaktiviert
        failed_job_alerts_empty: Keine Empfänger mit Opt-in
        failed_job_alerts_title: Empfänger für Fehler-E-Mails bei Hintergrundjobs
        generated_at: Erstellt am {timestamp}
        headers:
          channels: Kanäle
          delivery_status: Status
          occurrences: Vorkommen
          severity: Schweregrad
          title: Titel
          user: Benutzer
          when: Zeitpunkt
        heading: Portal-Benachrichtigungsbericht
        no_channel_data: Keine Daten
        quick_tests: Schnelltests für Benachrichtigungen
        read_label: Gelesen
        read_unread_series_label: Benachrichtigungen
        read_unread_title: Gelesen vs Ungelesen
        recent_notifications_title: Neueste Benachrichtigungen
        test_default_body: Generiert über den Admin-Benachrichtigungsbericht %{timestamp}
        test_default_title: "%{severity}-Benachrichtigungstest"
        test_event_type_label: Testereignistyp
        test_events:
          email: E-Mail-Zustellungstest
          portal: Portal-Toast-Test
        top_events_header_count: Anzahl
        top_events_header_event: Ereignis
        top_events_title: Top-Ereignisse
        top_recipients_header_count: Anzahl
        top_recipients_header_user: Benutzer
        top_recipients_title: Top-Empfänger
        totals_line: 'Aktiv: {active} • Ungelesen: {unread}'
        totals_title: Summen
        trigger_label_prefix: ''
        trigger_label_suffix: auslösen
        unknown_event: Unbekannt
        unread_label: Ungelesen
      safeguards:
        confirm_disable: "{channel}-Benachrichtigungen deaktivieren?"
        disabled: Deaktiviert
        enabled: Aktiviert
        never_disabled: Noch nie deaktiviert
        recipient_hint: Änderungen gelten sofort für neue Zustellungen.
        recipient_prompt: Wähle einen Benutzer, um seine Kanäle zu steuern.
        recipient_search: Empfänger finden
        recipient_subtitle: Kanäle für einzelne Benutzer in Notfällen pausieren.
        recipient_title: Empfänger-Overrides
        recipient_unavailable: Admin-Overrides sind in dieser Umgebung nicht verfügbar.
        refresh: Schutz aktualisieren
        subtitle: Not-Aus-Schalter stoppen jeden Kanal sofort.
        title: Schutzfunktionen
      tabs:
        compose: Erstellen & Senden
        reports: Berichte & Tests
      tray:
        admin_link: Benachrichtigungshub öffnen
        admin_link_hint: Verwalte Präferenzen und Details im Hub.
        dismiss: Verwerfen
        empty: Noch keine Benachrichtigungen.
        mark_read: Als gelesen markieren
        more_hint: "... +{count} weitere —"
        more_link: Im Benachrichtigungshub ansehen
        no_settings_user: Benachrichtigungseinstellungen sind in dieser Sitzung nicht verfügbar.
        settings_link: Benachrichtigungseinstellungen verwalten
        similar: Zustellungen
        tabs:
          notifications: Benachrichtigungen
          settings: Einstellungen
        view: Anzeigen
    email:
      generic:
        brand_heading: "%{brand}"
        button: Portal öffnen
        footer: Sie erhalten diese E-Mail, weil Benachrichtigungen für Ihr Konto aktiviert sind.
        meta:
          attempts: Versuche
          failed_at: Fehlgeschlagen am
          job_class: Jobklasse
          job_id: Job-ID
          queue: Warteschlange
          run_at: Geplant für
          sent_at: Gesendet am
        sections:
          details: Zustellungsdetails
          error_excerpt: Aktuelle Fehlermeldung
          handler_excerpt: Job-Payload
        title: Sie haben eine neue Benachrichtigung
    hub:
      actions:
        dismiss_all: Alles aufräumen
        load_more: Mehr laden
        mark_all_read: Alle als gelesen markieren
        refresh: Feed aktualisieren
      errors:
        notifications_fetch: Benachrichtigungen konnten nicht geladen werden.
        notifications_update: Benachrichtigungen konnten nicht aktualisiert werden. Bitte versuche es erneut.
        preference_update: Einstellungen konnten nicht aktualisiert werden. Bitte versuche es erneut.
      filters:
        range_30d: Letzte 30 Tage
        range_7d: Letzte 7 Tage
        range_all: Gesamter Zeitraum
        range_label: Zeitraum
        severity_all: Alle
        severity_attention: Handlungsbedarf
        severity_label: Anzeigen
        severity_success: Erfolgreich
        severity_updates: Updates
        visibility_all: Alle Einträge
        visibility_label: Status
        visibility_needs_action: Handlungsbedarf
        visibility_open: Offene Einträge
        visibility_unread: Nur ungelesen
      inbox:
        empty: Alles erledigt. Neue Benachrichtigungen erscheinen hier.
        groups:
          today: Heute
          undated: Ohne Zeitstempel
          yesterday: Gestern
        hero_body: Sieh dir aktuelle Hinweise an, verfolge offene Punkte und öffne Details an einem Ort.
        hero_title: Behalte den Überblick
        meta:
          just_now: gerade eben
          last_refreshed: 'Zuletzt aktualisiert: {value}'
          never_refreshed: Noch nicht synchronisiert
          range_label: Zeitraum
          total_label: Hinweise gesamt
          unread_label: Ungelesen
        subtitle: Verwalte deine Portalhinweise und halte die Glocke übersichtlich.
        title: Meine Benachrichtigungen
      preferences:
        coming_soon: Demnächst verfügbar
        delivery_section_title: Zustellkanäle
        email: E-Mail-Hinweise
        email_hint: Sende eine Kopie in dein Postfach für zusätzliche Sicherheit.
        failed_job_alerts: E-Mails bei Jobfehlern
        failed_job_alerts_hint: Nur Admins und Entwickler. Opt-in für E-Mails bei fehlgeschlagenen Hintergrundjobs.
        notice: Kritische Konto-E-Mails (z. B. Passwort-Reset) werden weiterhin zugestellt, selbst wenn E-Mail-Hinweise deaktiviert sind.
        sms: SMS-Hinweise
        sms_hint: SMS-Hinweise folgen in Kürze.
        subtitle: Wähle, wie du benachrichtigt werden möchtest. Manche transaktionalen E-Mails bleiben aktiv.
        system_opt_ins_hint: Betriebliche Benachrichtigungsabonnements, die keine Standard-Zustellkanäle sind.
        system_opt_ins_title: System-Opt-ins
        title: Zustellkanäle
        toast: In-App-Hinweise
        toast_hint: In-App-Hinweise steuern Echtzeit-Popups; Einträge in Hub und Glocke bleiben gespeichert.
      tabs:
        inbox: Meine Benachrichtigungen
    system:
      failed_job:
        body: 'Ein Hintergrundjob ist fehlgeschlagen (Job #%{job_id}, %{attempts} Versuche).'
        cta: Im Jobmonitor prüfen
        preview: Job %{job_id} schlug nach %{attempts} Versuchen fehl.
        subject: 'Hintergrundjob #%{job_id} ist fehlgeschlagen'
        title: Hintergrundjob fehlgeschlagen
